import {
  type OnDataOptions,
  useSubscription as useGqlSubscription,
} from '@apollo/client';
import { useCallback } from 'react';

import { type NotificationSubscriptionResult, useApp } from '@system/app';
import { USER_NOTIFICATION_SUBSCRIPTION } from '@system/app/queries/userNotification.subscription.gql';

export function useSubscription(): void {
  const { notification } = useApp();
  const { publish } = notification;

  const handleSubscription = useCallback(
    async (opts: OnDataOptions<NotificationSubscriptionResult>) => {
      const {
        data: { data },
      } = opts;
      if (!data) return;
      const {
        notification__user: { payload, type },
      } = data;

      let eventName = `${type}.${payload.type}.${payload.data.entity}`;
      if (eventName.at(eventName.length - 1) === '.') {
        eventName = eventName.slice(0, -1);
      }

      publish(eventName, payload);
    },
    [publish],
  );

  useGqlSubscription<NotificationSubscriptionResult>(
    USER_NOTIFICATION_SUBSCRIPTION,
    {
      onData: handleSubscription,
    },
  );
}
